module.exports = __webpack_public_path__ + "img/106.2063ae52.jpg";